export const NAME_ALREADY_EXISTS_MESSAGE = 'This name already exists';

export const normalizeVulnerabilityName = (value) => String(value ?? '').trim();

export const extractCommandIdFromResponse = (response) => (
  response?.command_id ??
  response?.commandId ??
  response?.metadata?.command_id ??
  response?.data?.command_id ??
  null
);

export const extractIsGroupingFromResponse = (response) => {
  const value = (
    response?.is_grouping ??
    response?.isGrouping ??
    response?.metadata?.is_grouping ??
    response?.metadata?.isGrouping ??
    response?.data?.is_grouping ??
    response?.data?.isGrouping ??
    null
  );

  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.trim().toLowerCase() === 'true';
  if (typeof value === 'number') return value === 1;
  return null;
};

export const buildGroupingCommandFromResponse = (
  response,
  {
    workspaceName,
    groupingStartTimestamp = Date.now(),
    commandId
  } = {}
) => {
  if (extractIsGroupingFromResponse(response) !== true) return null;

  return {
    command_id: commandId ?? extractCommandIdFromResponse(response) ?? null,
    commandType: 'grouping',
    name: workspaceName,
    fileType: 'grouping',
    isGrouping: true,
    groupingStartTimestamp,
    error: false,
    finished: false
  };
};

export const extractWorkspaceGroupByFromResponse = (response) => {
  const value = (
    response?.group_by ??
    response?.groupBy ??
    response?.workspace?.group_by ??
    response?.workspace?.groupBy ??
    response?.data?.group_by ??
    response?.data?.groupBy ??
    response?.data?.workspace?.group_by ??
    response?.data?.workspace?.groupBy ??
    null
  );

  if (value === null || typeof value === 'undefined') return null;
  return String(value).trim().toLowerCase();
};

export const extractUpdatedVulnerabilityFromResponse = (response, fallback = null) => {
  if (response?._id || response?.id) return response;

  const nestedVuln = (
    response?.vulnerability ??
    response?.vuln ??
    response?.data?.vulnerability ??
    response?.data?.vuln ??
    response?.data
  );

  if (nestedVuln?._id || nestedVuln?.id) return nestedVuln;
  return fallback;
};

export const getVulnerabilityNameErrorMessage = (error) => {
  const message = String(error?.message ?? '').trim();
  const normalizedMessage = message.toLowerCase();

  if (
    normalizedMessage.includes('already exists') ||
    normalizedMessage.includes('existing value') ||
    normalizedMessage.includes('duplicate')
  ) {
    return NAME_ALREADY_EXISTS_MESSAGE;
  }

  return message || 'An error occurred while updating the vulnerability name.';
};

export const isWorkspaceGroupedByName = (workspaceName, workspaces = []) => {
  const workspace = (Array.isArray(workspaces) ? workspaces : [])
    .find((item) => item?.name === workspaceName);

  return String(workspace?.group_by ?? '').trim().toLowerCase() === 'name';
};
